import {
  EnvironmentProviders,
  inject,
  provideEnvironmentInitializer,
} from '@angular/core';
import { GridPreferencesStore } from './grid-preferences.store';

/**
 * Provides an application-wide initializer that triggers preference loading
 * on application load.
 */
export function provideAppGridPreferences(): EnvironmentProviders {
  return provideEnvironmentInitializer(() => {
    const store = inject(GridPreferencesStore);
    store.loadPreferences();
  });
}
